import { isValidCUITCUIL } from "../../utils/utils";

export const rules = {
    cuit: [
        { required: true, message: "Debe ingresar un numero de CUIT" },

        {
            validator: (_, value) =>
                !value || isValidCUITCUIL(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Nro de CUIT/CUIL inválido")),
        },
    ],
    email: [
        { required: true, message: "Debe ingresar un email" },

        {
            validator: (_, value) => {
                if (!value) return Promise.resolve();
                else {
                    // Proceso parte de adelante del email (antes del dominio)
                    const [emailName, emailDomain] = value.split("@");
                    let parsedEmailName = emailName.replaceAll(".", "");
                    const parsedEmail = `${parsedEmailName}@${emailDomain}`;
                    //

                    let split = parsedEmail.split(".");
                    let cant = split.length;

                    if (cant !== 2 && cant !== 3)
                        return Promise.reject(new Error("Email inválido"));
                    else {
                        let result =
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))$/.test(
                                split[0]
                            );
                        if (!result)
                            return Promise.reject(new Error("Email inválido"));
                        if (cant === 2)
                            return split[1] !== "com" && split[1] !== "travel" && split[1] !== "net"
                                ? Promise.reject(new Error("Email inválido"))
                                : Promise.resolve();
                        if (cant === 3)
                            return split[1] !== "com" ||
                                (split[2] !== "ar" && split[2] !== "br")
                                ? Promise.reject(new Error("Email inválido"))
                                : Promise.resolve();
                    }
                }
            },
        },
    ],
};
